import { render, staticRenderFns } from "./PrivateDiscussionInstagram.vue?vue&type=template&id=bdb9573a"
import script from "./PrivateDiscussionInstagram.vue?vue&type=script&lang=js"
export * from "./PrivateDiscussionInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdb9573a')) {
      api.createRecord('bdb9573a', component.options)
    } else {
      api.reload('bdb9573a', component.options)
    }
    module.hot.accept("./PrivateDiscussionInstagram.vue?vue&type=template&id=bdb9573a", function () {
      api.rerender('bdb9573a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/moderation/PrivateDiscussionInstagram.vue"
export default component.exports